import { HttpClient } from '#client/http/index'
import {
  ListFavoriteTimetableParams,
  FavoriteTimetablesResponse,
  ListFavoriteFacilitiesParams,
  FavoriteFacilitiesResponse,
  ListFavoritesSearchAttributesResponse,
  FacilityId,
} from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'

export const listTimetables = async (
  { httpClient }: { httpClient: HttpClient },
  params?: ListFavoriteTimetableParams,
) => {
  const { data }: ApiResponse<FavoriteTimetablesResponse> =
    await httpClient.get('/user/favorites/timetables', { params })
  return data
}

export const listFacilities = async (
  { httpClient }: { httpClient: HttpClient },
  params?: ListFavoriteFacilitiesParams,
) => {
  const { data }: ApiResponse<FavoriteFacilitiesResponse> =
    await httpClient.get('/user/favorites/facilities', { params })
  return data
}

export const listSearchAttributes = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: ApiResponse<ListFavoritesSearchAttributesResponse> =
    await httpClient.get('/user/favorites/attributes')
  return data
}

export const addFacility = async (
  { httpClient }: { httpClient: HttpClient },
  facilityId: FacilityId,
) =>
  await httpClient.post('/user/favorites/facilities', {
    facility_id: facilityId,
  })

export const removeFacility = async (
  { httpClient }: { httpClient: HttpClient },
  facilityId: FacilityId,
) => await httpClient.delete(`/user/favorites/facilities/${facilityId}`)
